import { Component, ChangeDetectionStrategy, input, model } from '@angular/core';

// translation service
import { TranslatePipe } from '@ngx-translate/core'; 

import { AllowedFileExtensions } from '../../models/common';

import { MatButtonModule } from '@angular/material/button';
import { MatListModule } from '@angular/material/list';
import { MatIconModule } from '@angular/material/icon';
import { MatRippleModule } from '@angular/material/core';


@Component( {
  selector: 'app-drag-drop-upload',
  imports: [
    TranslatePipe,
    MatButtonModule,
    MatListModule,
    MatIconModule,
    MatRippleModule,
  ],
  templateUrl: './drag-drop-upload-component.html',
  styleUrls: ['./drag-drop-upload-component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
} )
export class DragDropUploadComponent
{
  multiple = input.required<boolean | false>();
  files = model.required<File[]>();
  isDragging = false;
  allowedFileExtensions = AllowedFileExtensions;

  onDragOver( event: DragEvent )
  {
    event.preventDefault();
    this.isDragging = true;
  }

  onDragLeave()
  {
    this.isDragging = false;
  }

  onDrop( event: DragEvent )
  {
    event.preventDefault();
    this.isDragging = false;
    if ( event.dataTransfer?.files )
    {
      this.addFiles( event.dataTransfer.files );
    }
  }

  onFileSelect( event: Event )
  {
    const input = event.target as HTMLInputElement;
    if ( input.files )
    {
      this.addFiles( input.files );
    }
  }

  private addFiles( fileList: FileList )
  {
    Array.from( fileList ).forEach( file =>
    {
      // check if file is allowed before pushing
      this.fileIsValid( file );

      this.files().push( file )
    });
    
  }

  private fileIsValid( file: File )
  {
    const parts = file.name.split( '.' );
    const extension = `.${parts[parts.length - 1]}`;
    if ( !this.allowedFileExtensions.includes( extension ) )
    {
      throw new Error( 'File extension not allowed' );
    }
  }
}
